import React, {useRef} from "react";
import { useForm } from "react-hook-form";
import emailjs from 'emailjs-com';
import Analytics from "./Analytics";

const Contact = () => {
  const form = useRef();
  const [showResults, setShowResults] = React.useState(false)
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data, e) => {
    e.preventDefault();
    console.log("Message submited: " + JSON.stringify(data));
    emailjs.sendForm('service_0qq2l9q', 'template_u10qqdk', form.current, 'user_MTVCjSbDM4JWME6qVjWZl')
      .then((result) => {
        console.log(result)
        if(result.text === 'OK'){
          console.log("OK")
          e.target.reset();
          setShowResults(true);
        }
          // window.location.reload()  //This is if you still want the page to reload (since e.preventDefault() cancelled that behavior) 
      }, (error) => {
          console.log(error.text);
      });
  };

  return (
    <>
      {showResults ? <div>
        <div className="alert alert-success text-center">
          Thanks, will get you touch soon. 
        </div>
      </div> : null}
      <form ref={form} className="contactform" onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="form-group">
              <input
                {...register("from_name", { required: true })}
                type="text"
                name="from_name"
                placeholder="YOUR NAME"
              />
              {errors.from_name && errors.from_name.type === "required" && (
                <span className="invalid-feedback">Name is required</span>
              )}
            </div>
          </div>
          {/* End .col */}

          <div className="col-12 col-md-6">
            <div className="form-group">
              <input
                {...register(
                  "from_email",
                  {
                    required: "Email is Required",
                    pattern: {
                      value: /\S+@\S+\.\S+/,
                      message: "Entered value does not match email format",
                    },
                  },
                  { required: true }
                )}
                type="email"
                name="from_email"
                placeholder="YOUR EMAIL"
              />
              {errors.from_email && (
                <span className="invalid-feedback">{errors.from_email.message}</span>
              )}
            </div>
          </div>
          {/* End .col */}

          <div className="col-12 col-md-12">
            <div className="form-group">
              <input
                {...register("subject", { required: true })}
                type="text"
                name="subject"
                placeholder="YOUR SUBJECT"
              />
              {errors.subject && (
                <span className="invalid-feedback">Message is required.</span>
              )}
            </div>
          </div>
          {/* End .col */}

          <div className="col-12">
            <div className="form-group">
              <textarea
                {...register("html_message", { required: true })}
                name="html_message"
                placeholder="YOUR MESSAGE"
              ></textarea>
              {errors.html_message && (
                <span className="invalid-feedback">Message is required.</span>
              )}
            </div>
          </div>
          {/* End .col */}

          <div className="col-12">
            <button type="submit" className="button">
              <span className="button-text">Send Message</span>
              <span className="button-icon fa fa-send"></span>
            </button>
          </div>
          {/* End .col */}
        </div>
      </form>

      {/* End contact */}
      <Analytics action="Contact" />
    </>
  );
};

export default Contact;
